import { paymentDataSources } from '@/Models';
import { sectionTypes } from '@/Components/Payments/Adyen/AdyenPaymentUtility';

function buildAvailablePaymentMethodsPayload(groupedItems) {
    const payload = {};
    for (const section of groupedItems) {
        const paymentMethods = section.paymentMethods.map(c => c.paymentDataSource);
        const sectionName = Object.keys(sectionTypes)
            .find(key => sectionTypes[key] === section.sectionType);

        if (paymentMethods.length > 0) {
            for (const [index, paymentMethod] of paymentMethods.entries()) {
                payload[`payment_method_${sectionName}_${index + 1}`] = paymentDataSources[paymentMethod].name;
            }
        }
    }

    return payload;
}

export function buildPaymentErrorPayload(selectedPaymentMethod) {
    return {
        payment_method: Object.keys(paymentDataSources)
            .find(key => paymentDataSources[key] === selectedPaymentMethod),
        event_version: 2,
    };
}

export function buildToggleVisibilityPayload(sectionType, isVisible, groupedItems) {
    const sectionName = Object.keys(sectionTypes)
        .find(key => sectionTypes[key] === sectionType);

    const payload = {
        is_visible: isVisible,
        section_name: sectionName,
    };

    const availablePaymentMethodsPayload = buildAvailablePaymentMethodsPayload(groupedItems);
    return { ...payload, ...availablePaymentMethodsPayload };
}

export function buildPaymentMethodChangePayload(paymentDataSource, sectionType, groupedItems) {
    const paymentMethodName = paymentDataSources[paymentDataSource].name;
    const sectionName = Object.keys(sectionTypes)
        .find(key => sectionTypes[key] === sectionType);

    const payload = {
        selected_payment_method: paymentMethodName,
        selected_payment_section_name: sectionName,
    };

    const availablePaymentMethodsPayload = buildAvailablePaymentMethodsPayload(groupedItems);
    return { ...payload, ...availablePaymentMethodsPayload };
}
